import React from 'react'

// redux
import { connect } from 'react-redux'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

function AdditionalInformation(props) {
    // props
    const { orderDetails } = props

    return (
        // page border box
        <div className="page-border-box mb-4">
            <div className="pbb-inner position-relative">
                <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Additional Information</p>
                {
                    /* frac item */
                    orderDetails?.orders?.coupon_code ? (
                        <p className="frac mb-2">
                            <span className="st-fw-600 me-1 text-capitalize">applied coupon code:</span>
                            {orderDetails.orders.coupon_code}
                        </p>
                    ) : null
                }
                {
                    /* frac item */
                    orderDetails?.orders?.ip ? (
                        <p className="frac mb-2">
                            <span className="st-fw-600 me-1 text-capitalize">IP Address:</span>
                            {orderDetails.orders.ip}
                        </p>
                    ) : null
                }
            </div>
        </div>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AdditionalInformation)